import React from 'react';
import logoBlack from '../../../assets/logo-noir.png';

import CONFIG from '../../../config';
import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import WidgetDatePicker from '../../../components/widgets/WidgetDatePicker';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetSelect from '../../../components/widgets/WidgetSelect';

import 'dayjs/locale/fr';
import axios from "axios";
import Base64 from 'crypto-js/enc-base64';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HomeIcon from '@mui/icons-material/Home';
import Link from '@mui/material/Link';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import sha256 from 'crypto-js/sha256';
import WorkIcon from '@mui/icons-material/Work';
import { useNavigate } from 'react-router-dom';
import WidgetInputVille from '../../../components/widgets/WidgetInputVille';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import WidgetSnackbar from '../../../components/widgets/WidgetSnackbar';
import WidgetAlertbox from '../../../components/widgets/WidgetAlertbox';


function FicheAdmin({ user, setUser }) {
  const navigate = useNavigate();
  const [snackUpdate, openSnackUpdate] = WidgetSnackbar("Utilisateur sauvegardé");
  const [snackMailcrea, openSnackMailcrea] = WidgetSnackbar("Mail envoyé");
  const [alertDelete, openAlertDelete] = WidgetAlertbox("Voulez vous vraiment supprimer ce compte ?");

  const [secteurOption, setSecteurOption] = React.useState({});
  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_secteurs', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            let res = {};
            for (let i = 0; i < response.data.length; i++) {
              const secteurItem = response.data[i];
              res[secteurItem.toLowerCase()] = secteurItem;
            }
            res["autre"] = "Autre...";

            setSecteurOption(res);
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);

  /* START: FORM */
  const [nom, setNom] = React.useState(null);
  const [prenom, setPrenom] = React.useState(null);
  const [email, setEmail] = React.useState(null);
  const [telephone, setTelephone] = React.useState(null);

  const [secteur, setSecteur] = React.useState(null);
  const [externe, setExterne] = React.useState(null);
  const [salaire, setSalaire] = React.useState(null);
  const [prime, setPrime] = React.useState(null);
  const [tva, setTva] = React.useState(null);

  const [disponibilite, setDisponibilite] = React.useState(null);
  const [dateRetourConge, setDateRetourConge] = React.useState(null);

  const form = [
    [nom, setNom],
    [prenom, setPrenom],
    [email, setEmail],
    [telephone, setTelephone],

    [secteur, setSecteur],
    [externe, setExterne],
    [salaire, setSalaire],
    [prime, setPrime],
    [tva, setTva],

    [disponibilite, setDisponibilite],
    [dateRetourConge, setDateRetourConge]
  ];
  /* END: FORM */


  const submitForm = (send_mail) => {
    // var formQuestionnaireValid = true;

    // if (nom === null || nom.value === '') {
    //   setNom((s) => ({ ...s, error: true }));
    //   formQuestionnaireValid = false;
    // }

    // if (prenom === null || prenom.value === '') {
    //   setPrenom((s) => ({ ...s, error: true }));
    //   formQuestionnaireValid = false;
    // }

    // if (!formQuestionnaireValid) {
    //   return;
    // }

    var payload = {};

    for (var i = 0; i < form.length; i++) {
      let [field, setField] = form[i];
      if (field !== null && field.value !== null && field.value !== '') {
        payload[field.id] = dayjs.isDayjs(field.value) ? field.value.toISOString() : field.value;
      }
    }

    axios.post(CONFIG.API_URL + '/api/client_save_user_intranet/' + user._id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setUser(response.data);
            openSnackUpdate();
            break;

          default:
            break;
        }

        if (send_mail) {
          axios.post(CONFIG.API_URL + '/api/creation_compte_mail/' + user._id, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then((response) => {
              switch (response.status) {
                case 200:
                  openSnackMailcrea();
                  break;

                default:
                  break;
              }
            })
            .catch((e) => {
              let response = e.response;

              if (response === undefined) {
                alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                return;
              }

              switch (response.status) {
                default:
                  alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                  break;
              }
            });
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  };


  return (
    <>
      {snackUpdate}
      {snackMailcrea}
      {alertDelete}
      <div className='max-w-4xl mx-auto shrink-0'>
        <div className='grid grid-cols-12 gap-x-4 m-6'>
          <div className='col-span-12 w-full text-center'>
            <h1>Information <b>utilisateur intranet</b></h1>
          </div>
        </div>

        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
          <div className='flex col-span-12 w-full mb-1 text-center items-end'>
            <div className='pr-2 text-ame-gray'>
              <PersonIcon fontSize='large'></PersonIcon>
            </div>
            <div>
              <h2>Informations personnelles</h2>
            </div>
          </div>

          <div className='col-span-12 w-full mb-4'>
            <hr></hr>
          </div>

          <div className='col-span-6 w-full mb-4'>
            <WidgetInputText state={nom} setState={setNom} id={'nom'} text={"Nom"} value={user.nom} />
          </div>

          <div className='col-span-6 w-full mb-4'>
            <WidgetInputText state={prenom} setState={setPrenom} id={'prenom'} text={"Prénom"} value={user.prenom} />
          </div>

          <div className='col-span-6 w-full mb-4'>
            <WidgetInputText state={email} setState={setEmail} id={'email'} text={"Email"} regex={"^.+@.+$"} regex_helper={"Adresse email non-valide"} value={user.email} />
          </div>

          <div className='col-span-6 w-full mb-4'>
            <WidgetInputText state={telephone} setState={setTelephone} id={'telephone'} text={"Téléphone"} regex_key={"[+0-9 ]"} value={user.telephone} />
          </div>
        </div>

        {user.roles.role_commercial &&
          <>
            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <WorkIcon fontSize='large'></WorkIcon>
                </div>
                <div>
                  <h2>Information commercial</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={secteur} setState={setSecteur} id={'secteur'} text={"Secteur"} value={user.informations_admin.secteur}
                  options={secteurOption}
                />
              </div>

              <div className='col-span-6 w-full mb-4 content-center grid pl-2'>
                <WidgetCheckbox state={externe} setState={setExterne} id={'externe'} text={"Interne"} value={user.informations_admin.externe} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={salaire} setState={setSalaire} id={'salaire'} text={"Salaire"} value={user.informations_admin.salaire} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={prime} setState={setPrime} id={'prime'} text={"Prime"} value={user.informations_admin.prime} />
              </div>

              <div className='col-span-12 w-full mb-4 content-center grid pl-2'>
                <WidgetCheckbox state={tva} setState={setTva} id={'tva'} text={"TVA"} value={user.informations_admin.tva} />
              </div>
            </div>



            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <AccessTimeFilledIcon fontSize='large'></AccessTimeFilledIcon>
                </div>
                <div>
                  <h2>Disponibilités</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={disponibilite} setState={setDisponibilite} id={'disponibilite'} text={"Disponivilités"} value={user.informations_admin.disponibilite}
                  options={{
                    'osef': "Non-renseigné",
                    'conge': "En congé",
                    '0d': "Pas de disponibilité",
                    '1d': "1 Disponibilité",
                    '2d': "2 Disponibilités",
                    '3d+': "3 Disponibilités ou plus"
                  }}
                />
              </div>

              {disponibilite !== null && disponibilite.value === 'conge' &&
                <div className='col-span-6 w-full mb-4 grid'>
                  <WidgetDatePicker state={dateRetourConge} setState={setDateRetourConge} id={'date_retour_conge'} text={"Date de retour de congé"} value={user.informations_admin.date_retour_conge} />
                </div>
              }
            </div>
          </>
        }

        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
          <div className='col-span-4 w-full text-left'>
            <div className='px-4 inline'>
              <Button variant='outlined' onClick={() => openAlertDelete(() => {
                axios.post(CONFIG.API_URL + '/api/client_delete/' + user._id, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                  .then((response) => {
                    switch (response.status) {
                      case 200:
                        navigate("/intranet/configuration");
                        break;

                      default:
                        break;
                    }
                  })
                  .catch((e) => {
                    let response = e.response;

                    if (response === undefined) {
                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                      return;
                    }

                    switch (response.status) {
                      default:
                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                        break;
                    }
                  });
              })}>
                Supprimer l'utilisateur
              </Button>
            </div>
          </div>
          <div className='col-span-8 w-full text-right'>
            {!user.email_verifie &&
              <div className='px-4 inline'>
                <Button variant='outlined' onClick={() => { submitForm(true) }}>
                  Envoyer le mail de création
                </Button>
              </div>
            }

            <div className='inline'>
              <Button variant='contained' onClick={() => { submitForm(false) }}>
                Mettre à jour
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FicheAdmin;